import React, { Component } from "react";
import { Row, Col, Card, CardBody, Button, Label, Alert } from "reactstrap";
import Page from "components/Page";
import { Textbox, Select } from "react-inputs-validation";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { ambienteAplicacion } from "../../constants/urls";
import { estaEnListaNegra, FetchDataCarritoHogar, LimpiarCarritoHogar, LimpiarListaNegra, setProductoActualCotizadoHogar } from "../../redux/actions/ACarritoProductos";
import { fetchConsultarIdentificacionAP } from "../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { sucursalesFetch } from "../../redux/actions/aRamos";
import { ErrorMsgConstants, infoIds } from "../../constants";
import { obtenerDatosHogar } from "../../utils/validaciones";
import { ramos } from "../../utils/constants";

const TiposIdentificacion = [
  { id: infoIds.codigoCedulaNum, name: "Cédula" },
  { id: infoIds.codigoRucNum, name: "Ruc" },
  { id: infoIds.codigoPasaporteNum, name: "Pasaporte" }
];

class CotizacionDatosPersonales extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      identificacionSelected: "",
      nombreSelected: "",
      tipoIdentificacionSelected: 1,
      longitudCedulaRuc: false,
      msgLongitud: "Por favor verificar que la longitud de la cédula sea de 10 dígitos.",
      msgLongitudRuc: "Por favor verificar que la longitud del ruc sea de 13 dígitos.",
      sucursalAsesor: this.props.datosAsesor.sucursalCodCore ? this.props.datosAsesor.sucursalCodCore : "001",
      codigoProductoEspecial: null,
      errorMessageIdentificacion: '',
      errorMessageNombre: '',
      datosCotizador : obtenerDatosHogar(null)
    };
    this.props.fethSucursales();
  }

  async componentDidMount() {
    this.props.limpiarDatosListaNegra()
    //Verificar si la accion es regresar y precargar los datos obteniendo informacion del carrito
    const queryParams = new URLSearchParams(this.props.location.search);

    let codigoProductoEspecial = queryParams.get("producto");
    if (codigoProductoEspecial != null) {

      this.setState({ codigoProductoEspecial: codigoProductoEspecial });

      this.setState({ datosCotizador: obtenerDatosHogar(codigoProductoEspecial) });

    } else {
      //console.log("No codigoProductoEspecial");
    }

    const back = queryParams.get('back');
    if (back && back === "true") {

      console.log('verLog', this.props.carrito.setCarritoHogar.carDatosContratante)
      if (this.props.carrito.setCarritoHogar && this.props.carrito.setCarritoHogar.carDatosContratante.cliIdentificacion) {
        let tipo = 1;
        if (this.props.carrito.setCarritoHogar.carDatosContratante.cliIdentificacion.length === 13) {
          tipo = 2;
        }

        if (this.props.carrito.setCarritoHogar.carDatosContratante.cliTipoIdentificacion) {
          tipo = parseInt(this.props.carrito.setCarritoHogar.carDatosContratante.cliTipoIdentificacion)
        }
        this.setState({
          tipoIdentificacionSelected: tipo,
          identificacionSelected: this.props.carrito.setCarritoHogar.carDatosContratante.cliIdentificacion ? this.props.carrito.setCarritoHogar.carDatosContratante.cliIdentificacion : "",
          nombreSelected: this.props.carrito.setCarritoHogar.carDatosContratante.nombreCompleto ? this.props.carrito.setCarritoHogar.carDatosContratante.nombreCompleto : "",
          sucursalAsesor: this.props.carrito.setCarritoHogar.carDatosAsesor.sucursalSeleccionada ? this.props.carrito.setCarritoHogar.carDatosAsesor.sucursalSeleccionada : "001"
        })
      }
    }
    else {
      await this.props.limpiarCarrito();
    }
  }


  toggleValidating(validate) {
    this.setState({ validate });
  }

  onValidateform = async () => {
    
    this.state.identificacionSelected.length==0
    ? this.setState({ errorMessageIdentificacion: true })
    : this.setState({ errorMessageIdentificacion: false });

   this.state.nombreSelected.length==0
    ? this.setState({ errorMessageNombre: true })
    : this.setState({ errorMessageNombre: false });

    console.log(this.state.identificacionSelected)
    console.log(this.state.nombreSelected)
    console.log(this.state.errorMessageIdentificacion)
    console.log(this.state.errorMessageNombre)
    
    let { identificacionSelected, nombreSelected, tipoIdentificacionSelected, longitudCedulaRuc, sucursalAsesor, codigoProductoEspecial, datosCotizador } = this.state;
    this.toggleValidating(true);
    
    let validacionCedulaRuc = true;

    console.log('identificacionSelected',identificacionSelected)
    if (tipoIdentificacionSelected.toString() === infoIds.codigoRucStr) {

      if (identificacionSelected.length < 13 || identificacionSelected.length > 13) {
        validacionCedulaRuc = false
        this.setState({ longitudCedulaRuc: true });
      }
    }
  
    else if ((tipoIdentificacionSelected.toString() === infoIds.codigoCedulaStr)) {
      if (identificacionSelected.length < 10 || identificacionSelected.length > 10 ) {
        validacionCedulaRuc = false
        this.setState({ longitudCedulaRuc: true });
      }
    }
    else if ((tipoIdentificacionSelected.toString() === infoIds.codigoPasaporteStr)) {
      validacionCedulaRuc = true
    }
    if (identificacionSelected !== "" && nombreSelected !== "" && validacionCedulaRuc) {


  


     var codigoProducto = 0

     switch (this.state.datosCotizador.producto) {
      case 'HOGAR ADVANCE':

      codigoProducto = 1
        
        break;

        case 'PLAN ABIERTO':

      codigoProducto = 2
        
        break;

        case 'HOGAR AIG':

        codigoProducto = 3
          
          break;
     
      default:
        break;
     }


      const datosAsesor = {

        sucursalSeleccionada: this.props.datosSucursales
          .sucursalSelecionadaAsesor,

        ambiente: ambienteAplicacion,
        emailAsesor: this.props.datosUsuarios.correo
          ? this.props.datosUsuarios.correo
          : "",
          nombreProducto: this.state.datosCotizador.producto,
          codigoProducto:codigoProducto,
         codigoRamo: ramos.HOGAR.codigo,
          nombreRamo: ramos.HOGAR.nombre
      }

      await this.props.checkInListaNegra(identificacionSelected, datosAsesor)
      if (this.props.datosListaNegra.inListaNegra === false) {
        let idCarrito = this.props.carrito.setCarritoHogar.mongoCarrito ? this.props.carrito.setCarritoHogar.mongoCarrito : "";
        //Datos a enviar al carrito
        const datosCarrito = {
          empresa: "AIGMETROPOLITANA",
          nombresAsegurados: nombreSelected,
          identificacionAsegurados: identificacionSelected,
          tipoIdentificacionAsegurados: tipoIdentificacionSelected,
          mongoAsesor: this.props.datosAsesor.cliCodigoCore,
          sucursal: sucursalAsesor,
          ambiente: ambienteAplicacion,
          plataforma: "WEB",
          producto: this.state.datosCotizador.producto,
          pasoCarrito: "inicioCarrito",
          mongoCarrito: idCarrito,
          datosAsesor: {
            nombre: `${this.props.datosAsesor.nombres} ${this.props.datosAsesor.apellidos}`,
            codigoCore: this.props.datosAsesor.cliCodigoCore,
            sucursalSeleccionada: sucursalAsesor,
            ambiente: ambienteAplicacion,
            emailAsesor: this.props.datosAsesor.correo ? this.props.datosAsesor.correo : '',
            brokerRUC: this.props.datosAsesor.brokerRUC ? this.props.datosAsesor.brokerRUC : '',
            brokerNombre: this.props.datosAsesor.brokerNombre ? this.props.datosAsesor.brokerNombre : '',
            brokerCodigo: this.props.datosAsesor.brokerCodigo ? this.props.datosAsesor.brokerCodigo : '',
          },
        }
        //console.log(JSON.stringify(datosCarrito))   
        await this.props.setCarrito(datosCarrito);
        if (this.props.carrito.carritoHogarError === false) {

          //Redireccionar paso 1
          this.props.history.push(
            {
              pathname: "/cotizacion-hogar",
              search: codigoProductoEspecial != null
                ? "?producto=" + codigoProductoEspecial
                : "",
            }
          );
        }
      }

    }

  }

  consultaCedula = async params => {
    const { identificacion, tipo } = params;
    this.setState({ nombreSelected: "" })
    await this.props.consultarIdentificacion({
      "empresa": "AIGMETROPOLITANA",
      "identificador": identificacion,
      "tipo": tipo
    })
    //verificar si la consulta del cliente devolvio informacion
    if (!this.props.datosIdentificacion.consultarIdentificacionAPhasError) {
      if (Object.keys(this.props.datosIdentificacion.IdentificacionAP).length > 0) {
        this.setState({
          nombreSelected: this.props.datosIdentificacion.IdentificacionAP[0].nombre,
        });
      }
    }
    setTimeout(() => this.setState({ validate: true }), 100)
  }


  render() {
    let { validate, identificacionSelected, nombreSelected, tipoIdentificacionSelected, longitudCedulaRuc, msgLongitud, msgLongitudRuc, sucursalAsesor } = this.state;
    let cargando = this.props.carrito.carritoHogarloading ? this.props.carrito.carritoHogarloading : false;
    let arraySucursales = [];
    this.props.sucursales.map(s => {
      arraySucursales.push({ id: s.sucCodigoCore, name: s.sucNombre });
    });
    return (
      <LoadingScreen
        loading={cargando || this.props.datosIdentificacion.consultarIdentificacionAPIsLoading || this.props.datosListaNegra.listaNegraLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Cargando..."
      >

        <Page title={this.state.datosCotizador.titulo} breadcrumbs={[{ name: this.state.datosCotizador.titulo, active: true }]}>

          <div className="container-step">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step current"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>
          <Row>
            <Col md={12} className="mb-3">
              <Card className="flex-row ">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }} className='mb-5'>Información del Contratante</h4>
                  <Row>
                    <Col lg={2}></Col>
                    <Col lg={8} md={12} sm={12} xs={12}>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Tipo de Identificación</Label></h5></Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                          <Select
                            id={"Tipo"} // Optional.[String].Default: "". Input ID.
                            name={"Tipo"} // Optional.[String].Default: "". Input name.
                            //value={datosCotizacion.datosPlaca.tipo!=="" ? datosCotizacion.datosPlaca.tipo :tipoSeleccionado} // Optional.[String].Default: "".
                            value={tipoIdentificacionSelected} // Optional.[String].Default: "".
                            optionList={TiposIdentificacion} // Required.[Array of Object(s)].Default: [].
                            onChange={(tipoidentificacion, e) => {
                              this.setState({ tipoIdentificacionSelected: tipoidentificacion,identificacionSelected: "" ,nombreSelected:''});
                            }} // Optional.[Func].Default: () => {}. Will return the value.
                            validate={validate}
                            validationCallback={res =>
                              //console.log(res)
                              this.setState({
                                hasTipoError: res,
                                validate: false
                              })
                            }

                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                            validationOption={{
                              name: "Tipos de Identificación", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              msgOnError: "Por favor seleccione un tipo de identificación."
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={2}></Col>
                  </Row>
                  <Row>
                    <Col lg={2}></Col>
                    <Col lg={8} md={12} sm={12} xs={12}>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Identificación</Label></h5></Col>
                        <Col lg={8} md={8} sm={12} xs={12}>

                          {(tipoIdentificacionSelected == 1 || tipoIdentificacionSelected == '1') &&

                            <Textbox
                              tabIndex="1"
                              type="input"
                              value={identificacionSelected}
                              name="identificacion"
                              id="identificacion"
                              placeholder="Ingrese la cédula identificacion de la persona Ejemplo (0105613045)."
                              classNameInput={"form-control"}
                              onChange={(identificacion, e) => {
                                const regex = /^[0-9]*$/;
                                if (regex.test(identificacion)) {
                                this.setState({ identificacionSelected: identificacion, longitudCedulaRuc: false });
                                if (identificacion.length === 10 && parseInt(tipoIdentificacionSelected) === 1) {
                                  this.consultaCedula({ identificacion: identificacion, tipo: "cedula" })
                                }

                                if (identificacion.length === 13 && parseInt(tipoIdentificacionSelected) === 2) {
                                  this.consultaCedula({ identificacion: identificacion, tipo: "ruc" })
                                }
                              }
                              }}
                              validate={validate}
                              validationCallback={res => this.setState({ validate: res })} // Optional.[Func].Default: none. Return the validation result.
                              onBlur={e => this.setState({ blur: true })}
                              // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              validationOption={{
                                name: "identificacion",
                                check: true,
                                type: 'number',
                                //type: parseInt(tipoIdentificacionSelected) == infoIds.codigoCedulaNum ? 'number' : parseInt(tipoIdentificacionSelected) == infoIds.codigoRucNum ? 'number' : this.state.tipoIdentificacionSelected == infoIds.codigoPasaporteNum ? 'alphanumeric' : 'number',
                                length: 10,
                                required: true,



                                msgOnError: "El número de cédula ingresado no es correcto." // Optional.[Bool].Default: true. To determin if it is a required field.
                              }}

                            />
                          }

                                {this.state.errorMessageIdentificacion && (tipoIdentificacionSelected == 1 || tipoIdentificacionSelected == '1')
                                  ? <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp" >El campo identificación no debe estar vacío.</div>
                                  : null
                                }

                          {(tipoIdentificacionSelected == 2 || tipoIdentificacionSelected == '2') &&

                            <Textbox
                              tabIndex="1"
                              type="input"
                              value={identificacionSelected}
                              name="identificacion2"
                              id="identificacion2"
                              placeholder="Ingrese el ruc de la persona Ejemplo (0105613045001)."
                              classNameInput={"form-control"}
                              onChange={(identificacion, e) => {
                                const regex = /^[0-9]*$/;
                                if (regex.test(identificacion)) {
                                this.setState({ identificacionSelected: identificacion, longitudCedulaRuc: false });
                                if (identificacion.length === 10 && parseInt(tipoIdentificacionSelected) === 1) {
                                  this.consultaCedula({ identificacion: identificacion, tipo: "cedula" })
                                }

                                if (identificacion.length === 13 && parseInt(tipoIdentificacionSelected) === 2) {
                                  this.consultaCedula({ identificacion: identificacion, tipo: "ruc" })
                                }
                              }}
                            }
                              validate={validate}
                              validationCallback={res => this.setState({ validate: res })} // Optional.[Func].Default: none. Return the validation result.
                              onBlur={e => this.setState({ blur: true })}
                              // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              validationOption={{
                                name: "identificacion",
                                check: true,
                                // type:'number',
                                //type: parseInt(tipoIdentificacionSelected) == infoIds.codigoCedulaNum ? 'number' : parseInt(tipoIdentificacionSelected) == infoIds.codigoRucNum ? 'number' : this.state.tipoIdentificacionSelected == infoIds.codigoPasaporteNum ? 'alphanumeric' : 'number',
                                reg: /^\d{13}$/,
                                required: true,


                                msgOnError: "El número de ruc ingresado no es correcto." // Optional.[Bool].Default: true. To determin if it is a required field.
                              }}

                            />
                          }

                          {this.state.errorMessageIdentificacion && (tipoIdentificacionSelected == 2 || tipoIdentificacionSelected == '2')
                            ? <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">El campo identificación no debe estar vacío.</div>
                            : null
                          }

                          {(tipoIdentificacionSelected == 3 || tipoIdentificacionSelected == '3') &&

                            <Textbox
                              tabIndex="1"
                              type="input"
                              value={identificacionSelected}
                              name="identificacion3"
                              id="identificacion2"
                              placeholder="Ingrese el pasaporte de la persona Ejemplo (2132313123123k23123)."
                              classNameInput={"form-control"}
                              onChange={(identificacion, e) => {
                                const regex = /^[a-zA-Z0-9]*$/;
                                if (regex.test(identificacion)) {
                                this.setState({ identificacionSelected: identificacion, longitudCedulaRuc: false });
                                if (identificacion.length === 10 && parseInt(tipoIdentificacionSelected) === 1) {
                                  this.consultaCedula({ identificacion: identificacion, tipo: "cedula" })
                                }

                                if (identificacion.length === 13 && parseInt(tipoIdentificacionSelected) === 2) {
                                  this.consultaCedula({ identificacion: identificacion, tipo: "ruc" })
                                }
                              }}}
                            
                              validate={validate}
                              validationCallback={res => this.setState({ validate: res })} // Optional.[Func].Default: none. Return the validation result.
                              onBlur={e => this.setState({ blur: true })}
                              // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              validationOption={{
                                name: "identificacion",
                                check: true,
                                required: true,
                                type: 'alphanumeric',
                                //type: parseInt(tipoIdentificacionSelected) == infoIds.codigoCedulaNum ? 'number' : parseInt(tipoIdentificacionSelected) == infoIds.codigoRucNum ? 'number' : this.state.tipoIdentificacionSelected == infoIds.codigoPasaporteNum ? 'alphanumeric' : 'number',

                                required: true,


                                msgOnError: "El número de pasaporte ingresado no es correcto." // Optional.[Bool].Default: true. To determin if it is a required field.
                              }}

                            />

                            
                          }

                          {this.state.errorMessageIdentificacion && (tipoIdentificacionSelected == 3 || tipoIdentificacionSelected == '3')
                            ? <div className="error-message" style={{ color: 'red' }}>El campo identificación no debe estar vacío.</div>
                            : null
                          }


                        </Col>
                      </Row>
                    </Col>
                    <Col lg={2}></Col>
                  </Row>

                  <Row> 
                    <Col lg={2}></Col>
                    <Col lg={8} md={12} sm={12} xs={12}>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Nombre</Label></h5></Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                          <Textbox
                            tabIndex="1"
                            type="input"
                            value={nombreSelected}
                            name="nombre"
                            id="nombre"
                            placeholder="Ingrese apellidos y nombres del Contratante"
                            classNameInput={"form-control"}
                            onChange={(nombre, e) => {
                              const valorFiltrado = nombre.toUpperCase().replace(/[^A-Za-zÁÉÍÓÚáéíóúÑñ& ]/g, "");
                              this.setState({ nombreSelected: valorFiltrado });
                            }}
                            validate={validate}
                            validationCallback={res => this.setState({ validate: !res })} // Optional.[Func].Default: none. Return the validation result.
                            onBlur={e => this.setState({ blur: true })}
                            // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            validationOption={{
                              name: "Nombres", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.                                
                              required: true,
                              reg: /^[A-Za-zÁÉÍÓÚáéíóúÑñ& ]+$/,
                              //reg: /^[0-9]+(\.[0-9]+)?$/, //Optional.[Bool].Default: "" Custom regex.                                    
                              msgOnError: "Debe ingresar apellidos y nombres del contratante" // Optional.[Bool].Default: true. To determin if it is a required field.
                            }}

                          />

                          {this.state.errorMessageNombre
                            ? <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">El campo nombre no debe estar vacío.</div>
                            : null
                          }
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={2}></Col>
                  </Row>
                  {this.props.datosAsesor.usu_tipo_usuario !== 'cliente' &&
                    <Row>
                      <Col lg={2}></Col>
                      <Col lg={8} md={12} sm={12} xs={12}>
                        <Row>
                          <Col lg={4} md={4} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Sucursal de Emisión</Label></h5></Col>
                          <Col lg={8} md={8} sm={12} xs={12}>
                            <Select
                              tabIndex="6" // Optional.[String or Number].Default: none.
                              id={"SelectSucursal"} // Optional.[String].Default: "". Input ID.
                              name={"SelectSucursal"} // Optional.[String].Default: "". Input name.
                              value={sucursalAsesor} // Optional.[String].Default: "".
                              optionList={arraySucursales} // Required.[Array of Object(s)].Default: [].
                              onChange={(selec, e) => {
                                //console.log(selec);
                                this.setState({ sucursalAsesor: selec });
                              }}
                              validate={validate}
                              validationCallback={res =>
                                //console.log(res) 
                                this.setState({
                                  hasCiudadError: res,
                                  validate: !res
                                })
                              }
                              // Optional.[Func].Default: () => {}. Will return the value.
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "SelectCiudad", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione una sucursal"
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={2}></Col>
                    </Row>
                  }

                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div style={{ textAlign: "center" }}>
                        <Button onClick={this.onValidateform} className="btn btn-primary">
                          <i className="fa fa-chevron-circle-right" aria-hidden="true" />{` CONTINUAR`}
                        </Button>
                        <p></p>
                        {this.props.carrito.carritoHogarError && this.props.carrito.carritoHogarError &&
                          <Alert color="danger" isOpen={this.state.visibleAlert} toggle={this.onDismiss}>
                            <center><p>Ha ocurrido un inconveniente al guardar la información. Por favor intente nuevamente.</p></center>
                          </Alert>
                        }
                      </div>
                    </Col>
                  </Row>

                  <div style={{ marginTop: '2rem' }}>

                    {/* Validacion de duplicidad */}
                    {console.log('test dup msg', this.props.datosListaNegra)}
                    {this.props.datosListaNegra.inListaNegra
                      ?
                      <Alert color="danger">
                        <center><p>{this.props.datosListaNegra.inListaNegraMensaje}</p></center>
                      </Alert>
                      :
                      null
                    }
                    {this.props.datosListaNegra.listaNegraError &&
                      <Alert color="danger">
                        <center><p>{ErrorMsgConstants.errorServicioListaNegra}</p></center>
                      </Alert>
                    }
                  </div>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Page>
      </LoadingScreen>

    );
  }
};

const mapStateToProps = state => ({
  catalogo: state.catalogosHogar,
  datosAsesor: state.datosUsuarios.dataUsuario,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  carrito: state.datosCarritoHogar,
  datosIdentificacion: state.datosIdentificacionAP,
  sucursales: state.datosSucursales.DataSucursales,
  datosSucursales: state.datosSucursales,
  datosListaNegra: state.datosListaNegra,
});

const mapDispatchToProps = dispatch => {
  return {
    setCarrito: (datosCarrito) => dispatch(FetchDataCarritoHogar(datosCarrito)),
    limpiarCarrito: () => dispatch(LimpiarCarritoHogar()),
    setProductoActual: (param) => dispatch(setProductoActualCotizadoHogar(param)),
    consultarIdentificacion: datos => dispatch(fetchConsultarIdentificacionAP(datos)),
    fethSucursales: () => dispatch(sucursalesFetch()),
    limpiarDatosListaNegra: () => dispatch(LimpiarListaNegra()),
    checkInListaNegra: (identificacion, datos) => dispatch(estaEnListaNegra(identificacion,datos)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionDatosPersonales)
);

